const data = [
  {
    title: 'Health screeners',
    info: 'Which of the following health checks did you complete? (Select all that apply)',
    apiName: 'screeners',
    answers: [
      {
        title: 'Bowel Cancer Screening',
        value: 'Bowel Cancer Screening'
      },
      {
        title: 'Breast Cancer Screening',
        value: 'Breast Cancer Screening'
      },
      {
        title: 'Heart Health Check',
        value: 'Heart Health Check'
      },
      {
        title: 'Other Lifestyle Check with GP (e.g. discussion about nutrition, physical activity, weight, diabetes risk and/or smoking)',
        value: 'Other Lifestyle Check with GP (e.g. discussion about nutrition, physical activity, weight, diabetes risk and/or smoking)'
      }
    ]
  },
  {
    title: 'How did you complete your health checks?',
    info: 'Where did you get the screener done?',
    apiName: 'places',
    answers: [
      {
        title: 'At a Medical Centre or GP Clinic',
        value: 'At a Medical Centre or GP Clinic'
      },
      {
        title: 'At a Specialists clinic',
        value: 'At a Specialists clinic'
      },
      {
        title: 'Breast Screen clinic',
        value: 'Breast Screen clinic'
      },
      {
        title: 'At home using a kit (for Bowel Cancer Screening only)',
        value: 'At home using a kit (for Bowel Cancer Screening only)'
      },
      {
        title: 'Other',
        value: 'Other'
      }
    ]
  }
]

export default data
